import { ShopsDropdown } from '~/components';

import { RemoteAppointmentInformation } from '../components';
import { PATH_NAMES } from '../constants';
import {
  PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
  EDIT_PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
} from './progress-bar-items.config';

export const config = {
  v2: {
    additionalShopTitle: 'Our Partners host virtual appointments by video or phone call. You can book at any shop or select one nearer to you.',
    searchResultTitle: 'Shops offering virtual appointments near',
    searchResultDescription: 'If you can\'t find a slot at a shop nearby, you can book at any other shop.',
    shopAddress: 'Virtual Service',
    ReviewForm: {
      shopDetails: {
        title: 'Service provided by',
      },
    },
    BookingInformation: {
      appointmentInformation: RemoteAppointmentInformation,
    },
    PROGRESS_BAR_ITEMS: PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
    EDIT_PROGRESS_BAR_ITEMS: EDIT_PROGRESS_BAR_ITEMS_FOR_VIRTUAL_SERVICE,
    shopsNextPath: PATH_NAMES.SELECT_DATE,
    selectDatePrevPath: PATH_NAMES.SELECT_SHOP,
    selectDateTitle: 'Select a date for your virtual appointment',
    subtitleComponent: ({ className, secondLineClassName }) => (
      <div className={className}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
        <p className={secondLineClassName}>If you can&apos;t find a preferred slot at your selected shop please try another one.</p>
      </div>
    ),
    ShopsDropdown,
    editShopNextPath: PATH_NAMES.EDIT_DATE,
    editDatePrevPath: PATH_NAMES.EDIT_SHOP,
    hideFilters: true,
  },
};
